module.exports = __webpack_public_path__ + "static/img/1-2.9c2d520.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/1-2.png
// module id = 6dg9
// module chunks = 0